import {useCallback, useEffect, useState} from "react";

import {IHandleState, ReservationFlowState} from "../types/ReservationFlowState";
import {hasReservationCountdown} from "../utils/get_reservation_code_step_view";

const COUNTDOWN_INTERVAL_MS = 1000;

export interface IReservationClock {
    // the moment the countdowns of the steps are shown for
    now: number;
    // call with every flow change, so that a countdown starts from the moment of the change
    refresh: () => void;
}

// Ticks every second only while a cooldown, a lock or a retry countdown runs
export const useReservationClock = (state: ReservationFlowState): IReservationClock => {
    const [now, setNow] = useState(() => Date.now());
    const refresh = useCallback(() => setNow(Date.now()), []);
    const isCountingDown = hasReservationCountdown(state, now);

    useEffect(() => {
        if (!isCountingDown) {
            return;
        }

        const intervalId = setInterval(refresh, COUNTDOWN_INTERVAL_MS);

        return () => clearInterval(intervalId);
    }, [isCountingDown, refresh]);

    return {now, refresh};
};

// the handle that still waits for its expiry
const getExpiringHandle = (state: ReservationFlowState): IHandleState | null =>
    (state.status === "code_entry" || state.status === "confirming") && !state.isExpired ? state : null;

// `onExpired` gets the handle the timer was set for - it has to be stable
export const useHandleExpiryTimer = (state: ReservationFlowState, onExpired: (handle: string) => void) => {
    const expiringHandle = getExpiringHandle(state);
    const handle = expiringHandle?.handle ?? null;
    const expiresAt = expiringHandle?.expiresAt ?? null;

    useEffect(() => {
        if (handle === null || expiresAt === null) {
            return;
        }

        const timeoutId = setTimeout(() => onExpired(handle), Math.max(0, expiresAt - Date.now()));

        return () => clearTimeout(timeoutId);
    }, [handle, expiresAt, onExpired]);
};
import {useCallback, useEffect, useState} from "react";

import {IHandleState, ReservationFlowState} from "../types/ReservationFlowState";
import {hasReservationCountdown} from "../utils/get_reservation_code_step_view";

const COUNTDOWN_INTERVAL_MS = 1000;

export interface IReservationClock {
    // the moment the countdowns of the steps are shown for
    now: number;
    // call with every flow change, so that a countdown starts from the moment of the change
    refresh: () => void;
}

// Ticks every second only while a cooldown, a lock or a retry countdown runs
export const useReservationClock = (state: ReservationFlowState): IReservationClock => {
    const [now, setNow] = useState(() => Date.now());
    const refresh = useCallback(() => setNow(Date.now()), []);
    const isCountingDown = hasReservationCountdown(state, now);

    useEffect(() => {
        if (!isCountingDown) {
            return;
        }

        const intervalId = setInterval(refresh, COUNTDOWN_INTERVAL_MS);

        return () => clearInterval(intervalId);
    }, [isCountingDown, refresh]);

    return {now, refresh};
};

// the handle that still waits for its expiry
const getExpiringHandle = (state: ReservationFlowState): IHandleState | null =>
    (state.status === "code_entry" || state.status === "confirming") && !state.isExpired ? state : null;

// `onExpired` gets the handle the timer was set for - it has to be stable
export const useHandleExpiryTimer = (state: ReservationFlowState, onExpired: (handle: string) => void) => {
    const expiringHandle = getExpiringHandle(state);
    const handle = expiringHandle?.handle ?? null;
    const expiresAt = expiringHandle?.expiresAt ?? null;

    useEffect(() => {
        if (handle === null || expiresAt === null) {
            return;
        }

        const timeoutId = setTimeout(() => onExpired(handle), Math.max(0, expiresAt - Date.now()));

        return () => clearTimeout(timeoutId);
    }, [handle, expiresAt, onExpired]);
};
